//#ca3b3f

export const darkTheme = {
    bg:"#1C1C27",        // Bg for All except About 
    bgLight: "#1C1E27",  // Nothing
    primary:"#854CE6",   // IMP Text
    text_primary:"#F2F3F4", // Headings and Description
    text_secondary:"#b1b2b3", // Sub Heading and Small Description
    card:"#171721",  // Skill, Project and Contact Card
    card_light: '#191924',  // Top bar and About BG
    button:"#854CE6", // Nothing
    white:"#FFFFFF",
    black:"#000000",
}

export const lightTheme = {
    bg:"#FFFFFF",
    bgLight: "#f0f0f0",
    primary:"#be1adb",
    text_primary:"#111111",
    text_secondary:"#48494a",
    card:"#FFFFFF",
    button:"#5c5b5b",
}